import { Compliance } from '@centecomm/portal-service';
import { createSelector } from 'reselect';
import { LoadStatus, State, StateRecord } from '../../Types';
import { Occupant, TenantUser } from './Types';

const welcomeState = ({ welcome }: State) => welcome;

export const occupantsSlice = createSelector(welcomeState, ({ occupants }): StateRecord<Occupant> => occupants);

export const occupantsLoadStatus = createSelector(occupantsSlice, ({ loadStatus }): LoadStatus => loadStatus);

export const occupants = createSelector(
    occupantsSlice,
    ({ loadStatus, errorState, sortOrder, ...rest }): Occupant[] => Object.values(rest) || [],
);

export const occupantsRequiringSetup = createSelector(occupants, (occupants): Occupant[] =>
    occupants.filter((_) => !_.setup),
);

export const isOccupantLoaded = (occupantId: number) =>
    createSelector(
        occupantsSlice,
        (occupants): boolean => occupants.loadStatus === LoadStatus.LOADED && occupants.hasOwnProperty(occupantId),
    );

export const occupantToSetup = createSelector(
    occupants,
    (occupants): Occupant | undefined => occupants.filter((_) => !_.setup)[0] || undefined,
);

export const occupantUsersSlice = createSelector(
    welcomeState,
    ({ occupantUsers }): Record<number, Record<number, TenantUser>> => occupantUsers,
);

export const occupantUsers = (occupantId: number) =>
    createSelector(occupantUsersSlice, (occupantUsers): TenantUser[] =>
        occupantUsers.hasOwnProperty(occupantId) ? Object.values(occupantUsers[occupantId]) : [],
    );

const complianceSlice = createSelector(
    welcomeState,
    ({ occupantCompliance }): Record<number, Compliance[]> => occupantCompliance,
);

export const complianceForOccupant = (occupantId: number | string) =>
    createSelector(complianceSlice, (occupantCompliance): Compliance[] | null =>
        occupantCompliance.hasOwnProperty(occupantId) ? occupantCompliance[occupantId] : null,
    );

export const welcomeFlowDone = createSelector(welcomeState, ({ welcomeFlowDone: done }): boolean => done);
